import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// NOTE: Firestore is deliberately NOT imported here. The live layer is RTDB
// (locked architecture decision) — importing firebase/firestore drags the whole
// Firestore SDK into the bundle for nothing.
const firebaseConfig = {
    apiKey: "AIzaSyDKrfl7cseb9SPA3YGAXu-ElFnsfVlhnQE",
    authDomain: "quiz-live-91c60.firebaseapp.com",
    databaseURL: "https://quiz-live-91c60-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "quiz-live-91c60",
    storageBucket: "quiz-live-91c60.firebasestorage.app",
    messagingSenderId: "687888844222",
    appId: "1:687888844222:web:12bf4c486f835121e925ef",
    measurementId: "G-18Z5GM8CVQ"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);

export { auth, db };
